<template>
    <div class="page-wrapper">

        <nav class="level m-t-md m-b-md">
            <div class="level-left">
                <div class="level-item">
                    <span id="tickets-total" class="title m-r-sm">{{ pagination.total }}</span> <span class="title m-r-sm">Tickets</span>
                </div>
                <div class="level-item">
                    <span class="title">
                        <b-button type="is-success m-r-sm" @click.prevent="goToLogTicket()">LOG TICKET</b-button>
                    </span>
                </div>
            </div>
            <div class="level-right">
                <div class="level-item"></div>
            </div>
        </nav>

        <div class="flex-wrap page-content">

            <div class="ticket-filters">

                <div class="buttons">
                    <b-button :type="myTickets ? 'is-info m-r-sm' : 'is-info is-outlined m-r-sm'" @click="getMyTickets">
                        MINE
                    </b-button>
                    <b-button
                        :type="ticketStatus.includes('open') ? 'is-warning m-r-sm' : 'is-warning is-outlined m-r-sm'"
                        @click.prevent="filterByStatus($event,'open')">
                        OPEN
                    </b-button>
                    <b-button
                        :type="ticketStatus.includes('closed') ? 'is-success m-r-sm' : 'is-success is-outlined m-r-sm'"
                        @click.prevent="filterByStatus($event,'closed')">
                        CLOSED
                    </b-button>
                    <b-button v-if="isNotUser()"
                        :type="ticketEscalated == true ? 'is-danger m-r-sm' : 'is-danger is-outlined m-r-sm'"
                        @click="changeEscalated($event)">
                        ESCALATED
                    </b-button>
                    <b-button
                        :type="ticketStatus.includes('void') ? 'is-dark m-r-sm' : 'is-dark is-outlined m-r-sm'"
                        @click.prevent="filterByStatus($event,'void')">
                        VOID
                    </b-button>
                    <b-button
                        :type="on_hold ? 'is-warning m-r-sm' : 'is-outlined m-r-sm'"
                        @click.prevent="on_hold = !on_hold, getTickets(1)">
                        ON HOLD
                    </b-button>
                    <b-button :type="isRank ? 'is-info m-r-sm' : 'm-r-sm is-outlined'" @click="rankMode($event)" v-if="isNotUser()">
                        RANK
                    </b-button>
                </div>

                <div class="level m-b-md">
                    <div class="level-left">
                        <div class="level-item">
                            <div class="is-inline-flex">

                                <app-filter :pre-select="this.$store.state.appSelected ? this.$store.state.appSelected : appSelected" v-model="appSelected" @input="getTickets(1)" :nullable="true" class="p-r-sm"/>

                                <b-field class="m-r-sm">
                                    <b-checkbox-button type="is-dark" native-value="Bug Report" v-model="type" @input="getTickets(1)">
                                        <b-tooltip label="Bug Report">
                                            <b-icon icon="bug"></b-icon>
                                        </b-tooltip>
                                    </b-checkbox-button>
                                    <b-checkbox-button type="is-dark" native-value="Feature Suggestion" v-model="type" @input="getTickets(1)">
                                        <b-tooltip label="Feature Suggestion">
                                            <b-icon icon="card-text"></b-icon>
                                        </b-tooltip>
                                    </b-checkbox-button>
                                    <b-checkbox-button type="is-dark" native-value="Service Request" v-model="type" @input="getTickets(1)">
                                        <b-tooltip label="Service Request">
                                            <b-icon icon="comment-alert"></b-icon>
                                        </b-tooltip>
                                    </b-checkbox-button>
                                </b-field>

                                <span class="custom-cancel" v-if="isRole('gatekeeper') && $route.query.release_id" @click="setRelease(null)">&times;</span>

                                <b-input
                                    class="m-r-sm"
                                    v-model="keyword"
                                    id="filter-reference"
                                    placeholder="Search Text/Number"
                                    @input="onReferenceInput"
                                ></b-input>

                                <b-taginput
                                    class="m-r-sm"
                                    v-model="tagsSelected"
                                    :data="filteredTags"
                                    placeholder="Search Tags"
                                    aria-close-label="REMOVE TAG"
                                    field="attributes.value"
                                    autocomplete
                                    open-on-focus
                                    :remove-on-keys="['Backspace']"
                                    :confirm-keys='[",", "Tab", "Enter"]'
                                    @typing="getFilteredTags"
                                    :allow-duplicates="false"
                                    ellipsis
                                    @input="getTickets(1)"
                                ></b-taginput>

                                <b-autocomplete v-if="isRole('serviceperson') || $route.query.release_id"
                                    v-model="releaseName"
                                    placeholder="Search Releases"
                                    :open-on-focus="true"
                                    :data="releases"
                                    field="name"
                                    @select="setRelease"
                                    @input="getReleases()"
                                    :clearable="isRole('gatekeeper') && $route.query.release_id ? false : true"
                                    ref="releases"
                                    class="button m-r-sm"
                                    :disabled="isRole('gatekeeper') && $route.query.release_id"
                                ></b-autocomplete>

                                <b-button id="reset" type="is-outlined" @click.prevent="resetFilters">RESET</b-button>

                            </div>
                        </div>
                    </div>
                    <div class="level-right">
                        <div class="level-item">
                            <b-field>
                                <b-button icon-left="file-delimited" @click="exportTickets('csv')"></b-button>
                            </b-field>
                        </div>
                        <div class="level-item">
                            <b-field>
                                <b-button icon-left="file-excel" @click="exportTickets('xlsx')"></b-button>
                            </b-field>
                        </div>
                    </div>
                </div>

            </div>

            <div class="flex-1" id="scroller">



                <b-table v-if="!isRank"
                    :data="tickets.length > 0 ? tickets : []"
                    :loading="tableloading"
                    narrowed
                    :show-header="false"
                    :mobile-cards="false"
                    :row-class="() => 'row-ticket'"
                    id="tickets-table"
                >

                    <template slot-scope="props">

                        <b-table-column
                            field="number"
                            cell-class="td-id"
                            class="is-narrow"
                            :data-id="props.row.id"
                        >
                            {{ props.row.id | makeIDSixDigits }}
                        </b-table-column>

                        <b-table-column
                            field="logged_at"
                            class="is-narrow"
                        >
                            {{props.row.attributes.created_at | date}}
                        </b-table-column>

                        <b-table-column
                            field="logged"
                            class="is-narrow"
                        >
                            <div class="field has-addons">
                                <p class="control">
                                    <b-tooltip :label="props.row.attributes.created_by.email"
                                        type="is-dark">
                                        <button class="button is-small is-warning">
                                            <span>{{getAbbreviation(props.row.attributes.created_by ? props.row.attributes.created_by.email : 'N/A')}}</span>
                                        </button>
                                    </b-tooltip>
                                </p>
                                <p class="control">

                                    <b-tooltip :label="props.row.attributes.app ? props.row.attributes.app.name : 'N/A'"
                                        type="is-dark">
                                        <button class="button is-info is-small">
                                            <span>{{getAbbreviation(props.row.attributes.app ? props.row.attributes.app.name : 'N/A')}}</span>
                                        </button>
                                    </b-tooltip>
                                </p>
                                <p class="control">
                                    <b-tooltip type="is-dark" :label="props.row.attributes.type.toUpperCase()">

                                        <button class="button is-small">
                                            <span class="icon ">
                                            <i :class="'mdi '+getIcon(props.row.attributes.type)+' mdi-18px'"></i></span>
                                        </button>
                                    </b-tooltip>
                                </p>
                                <p class="control" v-if="props.row.attributes.rank">
                                    <button class="button is-primary is-small">{{props.row.attributes.rank}}</button>
                                </p>
                            </div>
                        </b-table-column>

                        <b-table-column
                            field="priority"
                            class="is-narrow"
                        >
                            <div class="d-flex align-items-center">
                                {{ props.row.attributes.priority }}
                                <span
                                    class="icon has-text-danger"
                                    v-if=" props.row.attributes.is_escalated == 1 "
                                >
                                    <i class="mdi mdi-alert-decagram mdi-18px"></i>
                                </span>
                            </div>
                        </b-table-column>

                        <b-table-column
                            field="details"
                            class="ellipsis"
                            :title="props.row.attributes.details"
                        >
                            {{ props.row.attributes.details }}
                        </b-table-column>

                        <b-table-column
                            field="status"
                            class="is-narrow"
                        >
                            <span v-if="props.row.attributes.on_hold">ON HOLD</span>
                            <span v-else>{{ props.row.attributes.status.toUpperCase() }}</span>
                        </b-table-column>

                        <b-table-column field="id" class="minimum-possible">
                            <button
                                class="button is-small m-l-sm btn-edit"
                                @click.prevent="edit(props.row.id)"
                            >EDIT</button>
                        </b-table-column>

                    </template>

                    <!-- If Empty -->
                    <template slot="empty">
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p>
                                    <b-icon icon="alert-decagram-outline" size="is-large"></b-icon>
                                </p>
                                <p>NO RESULTS FOUND</p>
                            </div>
                        </section>
                    </template>

                </b-table>

                <draggable-table v-else :data.sync="tickets" @resetTickets="getTickets(pagination.currentPage)" :isLoading.sync="tableloading"/>

                <hr v-if="pagination.total>=1000">
                <b-pagination
                    v-if="pagination.total>=1000"
                    :total="pagination.total"
                    :current.sync="pagination.currentPage"
                    :order="pagination.order"
                    :size="pagination.size"
                    :simple="false"
                    :rounded="false"
                    :per-page="pagination.perPage"
                ></b-pagination>

            </div>

        </div>

    </div>
</template>

<script>
import Vue from "vue";
import _ from 'lodash';
import moment from "moment";
import { ExportToCsv } from 'export-to-csv';
import AppFilter from '../../../components/AppFilter';
import draggableTable from './draggableTable'

export default {
    components:{
        AppFilter,
        draggableTable
    },
    data() {
        return {
            tableloading: false,
            tickets: [],
            escalated: false,
            pagination: {
                total: 0,
                currentPage: 1,
                perPage: 0,
                order: "default",
                size: "default"
            },
            releases:[],
            release_id: null,
            releaseName:null,
            releaseTimeout:null,
            appSelected: null,
            fileType: null,
            type: [],
            types: ["Bug Report", "Feature Suggestion", "Service Request"],
            relationships:[
                'created_by',
                'point_id',
                'developer_id',
                'gatekeeper_id',
                'serviceperson_id',
                'ticket_parent_id',
                'app_id',
                'release_id'
            ],
            allowedColumns:[
                'Id',
                'Developer',
                'App_id',
                'Type',
                'Status',
                'Priority',
                'Details',
                'Release',
                'Release Notes',
                'Ticket Parent',
                'Is Escalated to Serviceperson',
                'Is Escalated to Developer',
                'Created By',
                'Serviceperson',
                'Gatekeeper',
                'Created at',
                'Updated at',
                'Point',
            ],
            notAllowedColumns:[
                'created_by',
                'point',
                'developer',
                'gatekeeper',
                'serviceperson',
                'parent',
                'app',
                'release'
            ],
            keyword: "",
            isQueryParamsFiltered: false,
            myTickets: false,
            tags:[],
            filteredTags:[],
            tagsSelected:null,
            debounceTags:null,
            openStatus:[
                'unresolved',
                'acknowledged',
                'work in progress',
                'queued',
                'developing',
                'ready for QA testing',
                'ready for UA testing',
                'ready for release',
                'released'
            ],
            isRank:false,
            on_hold: false,
        };
    },
    watch: {
        "pagination.currentPage"(value) {
            this.tableloading = true;
            this.getTickets(value);
        },
        // filterAppText(value) {
        //     if(value===''){
        //         this.appSelected = null
        //         this.getTickets(1)
        //     }
        // },
        releaseName(value){
            if(value===''){
                this.release_id = null
                this.getTickets(1)
            }
        }
    },
    computed: {
        auth: {
            get() {
                return this.$store.state.auth;
            }
        },
        ticketStatus: {
            get() {
                return this.$store.state.ticketStatus;
            },
            set(value) {
                this.$store.commit("SET_TICKET_STATUS", value);
            }
        },
        ticketEscalated: {
            get() {
                return this.$store.state.ticketEscalated;
            },
            set(value) {
                this.$store.commit("SET_TICKET_ESCALATED", value);
            }
        },
        referrer() {
            return document.referrer
        },

        loading: {
            get() {
                return this.$store.state.loading;
            },
            set(value) {
                this.$store.commit("SET_LOADING", value);
            }
        },
        apps(){
            return this.$store.state.apps
        }
    },
    async mounted() {
        this.loading = true;
        await this.getPreviousFilter();
        await this.getReleases();
        if(this.referrer==='' || this.referrer===null || this.referrer.includes(process.env.VUE_APP_URL)){
            await this.getTickets(1);
        }
        this.loading = false;
    },
    beforeDestroy() {
        this.$store.commit("SET_SUCCESS_MESSAGE", null);
        this.$store.commit("SET_ERRORS", null);
    },
    methods: {
        getTickets(page) {
            this.tableloading = true;
            let params = this.getParams(page);
            Vue.$ticketService.ticketList(params).then(response => {
                this.tickets = response.data;
                this.pagination.total = response.meta.pagination.total;
                this.pagination.currentPage =
                    response.meta.pagination.current_page;
                this.pagination.perPage = response.meta.pagination.per_page;
                this.tableloading = false;
            });
        },
        async getReleaseOnQuery(){
            if(!this.release_id){
                this.release_id = this.$route.query.release_id
            }
            let filteredRelease = await this.releases.filter(element => {
                return parseInt(element.id) === parseInt(this.release_id)
            })
            if(filteredRelease.length){
                this.releaseName = filteredRelease[0].name
                this.getTickets(1)
            }
        },
        getParams(page,isArray = false) {
            let params = `?page=${page ? page : 1}`;
            let arrayParams = {};
            if (this.ticketStatus) {
                let status = "";
                let statusArray = [];
                if(this.ticketStatus.includes('open')){
                    this.openStatus.forEach(element=>{
                        status+=`&status[${statusArray.length}]=${element}`
                        statusArray.push(element);
                    })
                }

                if(this.ticketStatus.includes('closed')){
                    status+=`&status[${statusArray.length}]=resolved`
                    statusArray.push('resolved');
                }

                if(this.ticketStatus.includes('void')){
                    status+=`&status[${statusArray.length}]=void`
                    statusArray.push('void');
                }
                params+=status;
                arrayParams['status'] = statusArray;
            }
            if (this.ticketEscalated) {
                params = params + `&escalated=${this.ticketEscalated ? 1 : 0}`;
                arrayParams['escalated'] = this.ticketEscalated ? 1 : 0;
            }

            if (this.type) {
                params = params + `&type=${this.type}`;
                arrayParams['type'] = this.type;
            }

            if (this.release_id) {
                params = params + `&release_id=${this.release_id}`;
                arrayParams['release_id'] = this.release_id;
            }
            if(this.appSelected) {
                params+=`&app_id=${this.appSelected}`;
                arrayParams['app_id'] = this.appSelected;
            }
            if (this.keyword) {
                params+=`&keyword=${this.keyword}`;
                arrayParams['keyword'] = this.keyword;
            }
            if(this.myTickets){
                params+=`&created_by=${this.$store.state.user.id}`;
                arrayParams['created_by'] = this.$store.state.user.id;
            }
            if(this.tagsSelected && this.tagsSelected.length){
                let tags = "";
                let tagsArray = [];
                this.tagsSelected.forEach((val, index) => {
                    tags = tags + `&tags[${index}]=${val.id}`;
                    tagsArray.push(val.attributes.value);
                });
                arrayParams['tags'] = tagsArray;
                params = params + tags;
            }

            if (this.on_hold) {
                params = params + "&on_hold=1";
                arrayParams['on_hold'] = 1;
            }

            localStorage['ticketFilters'] = JSON.stringify(arrayParams);

            return isArray ? arrayParams : params;
        },
        async getReleases() {
            this.loading = true;
            clearTimeout(this.releaseTimeout)
            let params = {
                name: this.releaseName,
                status: !this.releaseName ? 'pending' : null,
            }
            if(!this.isQueryParamsFiltered && (this.$route.query.release_id || this.release_id)){
                params.id = this.$route.query.release_id ? this.$route.query.release_id : this.release_id
                params.status = null

                Vue.$releaseService.releaseAsOptions(params).then(async (response)=>{
                    this.releases = response.data
                    if(!this.isQueryParamsFiltered){
                        await this.getReleaseOnQuery()
                        this.loading = false
                        this.isQueryParamsFiltered = true;
                    }
                })
            }else{
                this.releaseTimeout = setTimeout(()=>{
                    Vue.$releaseService.releaseAsOptions(params).then(async (response)=>{
                        this.releases = response.data
                    })
                },1000)
                this.loading = false
            }
        },
        async filterByStatus(event,status) {
            if (this.ticketStatus.includes(status)) {
                this.ticketStatus = this.ticketStatus.filter(
                    item => item !== status
                );
            } else {
                let ticketStatus = this.ticketStatus;
                ticketStatus.push(status);
                this.ticketStatus = ticketStatus
            }
            if(!this.ticketStatus.length){
                this.ticketStatus.push('open')
            }
            event.path[1].blur();
            await this.getTickets(this.pagination.currentPage);
        },
        goToLogTicket() {
            this.$router.push({
                name: "tickets.create"
            });
        },
        edit(id) {
            this.$router.push({
                name: "tickets.edit",
                params: {
                    id: id
                }
            });
        },
        changeEscalated(event) {
            this.ticketEscalated = !this.ticketEscalated;
            this.getTickets(1);
            event.path[1].blur();
        },

        async getPreviousFilter() {
            const filter = JSON.parse(localStorage.getItem('ticketFilters'));
            if(filter){
                if (filter.status.length) {
                    if(filter.status.includes('unresolved')){
                        this.ticketStatus.push('open');
                    }
                    if(filter.status.includes('resolved')){
                        this.ticketStatus.push('closed');
                    }
                    if(filter.status.includes('void')){
                        this.ticketStatus.push('void');
                    }
                }else{
                    this.ticketStatus = ['open']
                }

                if(filter.escalated){
                    this.ticketEscalated = true
                }
                if(filter.app_id){
                    this.appSelected = filter.app_id
                }
                if(filter.type){
                    this.type = filter.type
                }
                if(filter.release_id){
                    this.release_id = filter.release_id
                }
                if(filter.keyword) {
                    this.keyword = filter.keyword
                }
                if(filter.created_by){
                    this.myTickets = true
                }
                if(filter.tags){
                    let tagsSelected = []
                    await filter.tags.forEach((value)=>{
                        Vue.$tagService.getList('?filter=user_tag&keyword='+value).then((response)=>{
                            tagsSelected.push(response.data.filter((element)=>{
                                return element.attributes.value===value
                            })[0])
                        })
                    })
                    this.tagsSelected = tagsSelected
                }
            }else{
                this.ticketStatus = ['open']
            }

            return;
        },

        // setApp(value){
        //     if(value){
        //         this.appSelected = value.id
        //         this.getTickets(1)
        //     }
        // },
        exportTickets(fileType) {
            let params = this.getParams(null,true)
            params['fileType'] = fileType;
            if(fileType!==null){
                Vue.$ticketService.exportTickets(params).then((response)=>{
                    if(fileType==='xlsx'){
                        this.$buefy.toast.open({
                            type: 'is-success',
                            message:'Export has started. You will be notified once your export file is ready.',
                            duration: 10000,
                        });
                    }else{
                        let relationships = this.relationships
                        let notAllowedColumns = this.notAllowedColumns
                        let data = [];
                        response.data.map((e) => {
                            let values = _.map(Object.keys(e),(key)=>{
                                if(!notAllowedColumns.includes(key)){
                                    if(e[key]===null){
                                        return 'N/A'
                                    }
                                    if(relationships.includes(key) && e[key]!==null){
                                        let relationshipKey = key.replace('_id','').replace('ticket_','')
                                        return e[relationshipKey].name
                                    }
                                    if(typeof e[key]!=='object'){
                                        return e[key]
                                    }
                                }
                                return ''
                            })
                            data.push(values)
                        });
                        let now = moment().format('YYYY-MM-DD hh:mm:ss');
                        const options = {
                            fieldSeparator: ',',
                            quoteStrings: '"',
                            filename:`Tickets ${now}`,
                            decimalSeparator: '.',
                            showLabels: true,
                            useTextFile: false,
                            useBom: true,
                            useKeysAsHeaders: false,
                            headers:this.allowedColumns
                        };
                        let csvExporter = new ExportToCsv(options)

                        csvExporter.generateCsv(data);
                    }
                })
            }else{
                this.$buefy.toast.open({
                    type: 'is-danger',
                    message:'Select which file type to export.',
                    duration: 5000,
                });
            }
        },
        setRelease(option){
            if(option){
                this.release_id=option.id
            }else{
                this.release_id = null
                this.releaseName = null
                this.$router.replace({query:{}})
            }
            this.getTickets(1)
        },
        onReferenceInput: _.debounce(
            function() { this.getTickets(1) },
            500
        ),
        getMyTickets(event){
            this.myTickets = !this.myTickets
            event.path[1].blur();
            this.getTickets(1)
        },
        getFilteredTags(text){
            clearTimeout(this.debounceTags)
            this.debounceTags = setTimeout(()=>{
                Vue.$tagService.getList('?filter=user_tag&keyword='+text).then((response)=>{
                    this.filteredTags=response.data
                })
            },1000)
        },
        async resetFilters(){
            this.ticketStatus = ['open']
            this.appSelected = null
            this.type = null
            this.releaseName = null
            this.keyword = null
            this.release_id = null
            this.tags = []
            this.tagsSelected = []
            this.getTickets(1)
        },
        rankMode(event){
            this.isRank = !this.isRank
            event.path[1].blur();
        }
    }
};
</script>
<style scoped>
.user-dialog{
    background-color: #363636;
    color: white;
    bottom: -14px;
    padding: 5px;
    border-radius: 5px;
    display: inherit;
    position: absolute;
    left: 5px;
}
.user-popover{
    width: 0;
    height: 0;
    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
    border-right: 7px solid #363636;
    margin: -21px 0px 0px 20px;
    display:none;
    position: absolute;
}

.user-icon:hover ~ .user-popover{
    display:block;
}
.custom-cancel{
    cursor: pointer;
    padding: 0px 4px;
    height: 22px;
    border-radius: 48px;
    margin:5px;
    margin-top: 6px;
    background: #b36cd5;
    color: white;
    font-size: 24px;
    display: flex;
    align-items: center;
}
</style>
